import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const setAuthHeader = (token) => {
  if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete axios.defaults.headers.common.Authorization;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [token, setToken] = useState(() => localStorage.getItem("ao2_token") || "");

  useEffect(() => {
    const boot = async () => {
      const t = localStorage.getItem("ao2_token");
      if (!t) {
        setUser(false);
        return;
      }
      setAuthHeader(t);
      try {
        const { data } = await axios.get(`${API}/auth/me`);
        setUser(data.user);
      } catch {
        localStorage.removeItem("ao2_token");
        setAuthHeader(null);
        setUser(false);
      }
    };
    boot();
  }, []);

  const persist = (data) => {
    localStorage.setItem("ao2_token", data.token);
    setToken(data.token);
    setAuthHeader(data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    persist(data);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password });
    persist(data);
    return data.user;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch {}
    localStorage.removeItem("ao2_token");
    setToken("");
    setAuthHeader(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
